import { useState } from "react";
import { put } from "@common/api/apiShared";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { useDotLegalMutation, useDotLegalQuery, useDotLegalQueryClient } from "@common/hooks/dotLegalReactQuery";
import { ContractGlobalSettingSaveModel, ContractGlobalSettingViewModel } from "./ContractGlobalSettings.types";

const url = "/contract-global-settings";

export interface IContractGlobalSettingsDialogProps {
    onDialogClose: () => void;
}

export function useContractGlobalSettingsHook(props: IContractGlobalSettingsDialogProps) {
    const queryClient = useDotLegalQueryClient();
    const snackbar = useDotLegalSnackbar();
    const { translateString } = useTranslation();
    const { isLoading, data } = useDotLegalQuery<ContractGlobalSettingViewModel>(url);

    const [editedSaveModel, setEditedSaveModel] = useState<ContractGlobalSettingSaveModel | undefined>(undefined);
    const saveModel: ContractGlobalSettingSaveModel = editedSaveModel ?? { archiveContractsWhenExpired: data?.archiveContractsWhenExpired ?? false };

    const modelUpdater = {
        onArchiveContractsWhenExpiredChange: (archiveContractsWhenExpired: boolean) => setEditedSaveModel({ ...saveModel, archiveContractsWhenExpired }),
    };

    const saveMutation = useDotLegalMutation(() => put(url, saveModel));
    const onSave = async () => {
        await saveMutation.mutateAsync(undefined, {
            onSuccess: () => {
                queryClient.refetchQueries(url);
                props.onDialogClose();
                snackbar.show(translateString("contractSettingsSaved"));
            },
        });
    };

    return {
        isLoading,
        saveModel,
        editedSaveModel,
        modelUpdater,
        onSave,
        inProgress: saveMutation.isLoading,
    };
}
